<template>
  <div class="login-form">
    <div class="login-form-content">
      <form id="retrieve-password-form-modal" class="login-form-forgotten-section active">
        <div class="close-button">
          <a class="icon-close" @click.prevent="onExit"> </a>
        </div>
        <h2 class="heading heading__sm"><span class="orange-line">Retrieve</span> your password</h2>

        <label class="form-label" for="email"> Enter your e-mail address to retrieve your password </label>
        <input
          type="text"
          id="retrieve-email"
          class="form-control"
          data-validation="email"
          v-model.trim="retrieve.email"
        />
        <ButtonArrow type="submit" class="btn-yellow"> Retrieve Password </ButtonArrow>
      </form>
    </div>

    <div class="login-form-image" :class="login.type">
      <div class="close-button">
        <a class="icon-close" @click.prevent="closeModal()"> </a>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonArrow from '../button-arrow/ButtonArrow'
import auth from '../../../auth'

export default {
  name: 'RetrievePasswordForm',
  components: {
    ButtonArrow,
  },
  props: {
    onExit: {
      type: Function,
      default: () => {},
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
    onPasswordRetrieval: {
      type: Function,
      default: () => {},
    },
    lt: {
      type: String,
      default: 'podcaster',
    },
  },
  data: function () {
    return {
      login: {
        username: '',
        password: '',
        type: this.lt,
      },
      retrieve: {
        email: '',
      },
    }
  },
  mounted: function () {
    var self = this
    $.validate({
      form: '#retrieve-password-form-modal',
      modules: 'html5',
      validateOnBlur: false,
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function ($form) {
        self.retrievePassword()
        $('#retrievePasswordModal').modal('hide')
        return false
      },
    })
  },
  methods: {
    retrievePassword: function () {
      this.$log.info('retrieving password')
      var credentials = {
        email: this.retrieve.email,
      }

      auth.retrievePassword(this, credentials)
      this.retrieve = {
        email: '',
      }

      this.onPasswordRetrieval()
    },
    closeModal: function () {
      $('#retrievePasswordModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reused-components/retrieve-password-form/RetrievePasswordForm.vue